import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useReveal } from "../hooks/useReveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const { ref, visible } = useReveal();

  const submit = async (e) => {
    e.preventDefault();
    if (!email || loading) return;
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      setDone(true);
      setEmail("");
      toast.success("You're subscribed.", { description: "Thanks for joining the list." });
    } catch (err) {
      const msg = err?.response?.data?.detail || "Something went wrong. Please try again.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="newsletter"
      data-testid="newsletter-section"
      ref={ref}
      className={`relative bg-[#FAFBFC] py-32 md:py-48 px-6 md:px-12 lg:px-20 reveal ${
        visible ? "in-view" : ""
      }`}
    >
      <div className="max-w-2xl mx-auto text-center">
        <div className="overline mb-6">newsletter</div>

        <h2 className="font-serif-display text-5xl md:text-7xl text-[#0A0A0A] leading-[0.95] mb-8 tracking-tight">
          Stay in <span className="italic">touch.</span>
        </h2>

        <p className="text-base md:text-lg text-[#595959] leading-relaxed mb-14 max-w-lg mx-auto">
          Subscribe to be the first to hear about new music, tour dates, merch drops, and more.
        </p>

        {!done ? (
          <form
            data-testid="newsletter-form"
            onSubmit={submit}
            className="max-w-md mx-auto flex flex-col sm:flex-row items-stretch gap-4 sm:gap-3"
          >
            <input
              data-testid="newsletter-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="email address"
              className="newsletter-input flex-1 text-center sm:text-left"
            />
            <button
              data-testid="newsletter-submit-button"
              type="submit"
              disabled={loading}
              className="btn-minimal disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? "..." : "Subscribe"}
            </button>
          </form>
        ) : (
          <div
            data-testid="newsletter-success"
            className="font-serif-display italic text-2xl text-[#6B8FAE]"
          >
            Thanks for subscribing.
          </div>
        )}

        <p className="mt-10 font-mono-meta text-[10px] tracking-[0.3em] uppercase text-[#8C8C8C]">
          unsubscribe anytime.
        </p>
      </div>
    </section>
  );
}
